<template>
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <top-nav :page_title="page_title"></top-nav>

      <!-- FLASH MESSAGES -->
      <FlashMessage :position="'right bottom'"></FlashMessage>

<div class="main-content1">
  <div class="info-card">
    <div class="card">
      <div class="card-icon">
        <span><i class="fas fa-layer-group"></i></span>
      </div>
      <div class="card-detail">
        <h4>Projects</h4>
        <h2>{{ totalProjects }}</h2>
      </div>
    </div>
    <div class="card">
      <div class="card-icon">
        <span><i class="fas fa-layer-group"></i></span>
      </div>
      <div class="card-detail">
        <h4>Samples</h4>
        <h2>{{ totalSamples }}</h2>
      </div>
  </div>
    <div class="card">
      <div class="card-icon">
        <span><i class="fas fa-layer-group"></i></span>
      </div>
      <div class="card-detail">
        <h4>Themes</h4>
        <h2>{{ totalThemes }}</h2>
      </div>
</div>
<div class="login-signup" style="width:100%; margin:50px;display:flex; align-content: center;padding: 30px;background: linear-gradient(#ff512f , #dd2476);border-radius: 10px;color: white;box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;">
  <!-- <div style="flex:1;">
    <img :src="getCompanyLogo()" alt="Logo" class="menu_logo"/>
  </div> -->
  <div style="flex:1;display: flex;justify-content: center;">
    <!-- <h3>Get started</h3><br> -->
    <router-link to="/register"><Button style="box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;" class="btn btn-amber">Sign up</Button></router-link>
    <router-link to="/login"><Button  style="box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;" class="btn btn-blue">Log in</Button></router-link>
  </div>
</div>
<!--    <div class="content2">


    <div class="clock">
      <div class="info-card2">
        <div class="card2">
         <div class="card-icon2">
           <span><i class="fas fa-layer-group"></i></span>
         </div>
&lt;!&ndash;          <div class="card-detail2">&ndash;&gt;
           <h4>Projects</h4>
           <h2>150</h2>
         </div>
          <div>
            <img :src="getCompanyLogo()" alt="Logo" class="menu_logo"/>
          </div>
          <div class="text">
            <h3>Get started</h3><br>
            <router-link to="/register"><Button style="box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;" class="btn btn-amber">Sign up</Button></router-link>
            <router-link to="/login"><Button  style="box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;" class="btn btn-blue">Log in</Button></router-link>
          </div>
        </div>
        </div>
    </div>

    </div>-->
  </div>
      <!-- MAP COMPONENT -->

    </div>
  </div>


    <!-- <div style="height:100%;width:100%; border: 2px solid yellow;margin: 50px;padding:10px;box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;">
      <Map/>
    </div> -->
</div>



</div>

</template>

<script>
  // import Map from '@/components/MapView';
  import TopNav from "@/components/TopNav";
  import { sample_resource,project_resource,theme_resource } from "@/utils/api_paths";
  import {getLoggedInUser, handleError, pageStartLoader } from "@/utils/util_functions";
  import axios from "axios";

  export default {
    components: {
      // Map,
      TopNav
    },        
    created() { this.onPageLoad() },
    methods: {
      getCompanyLogo() {
        return require('@/assets/icipe-logo-web-200px-jpg.jpg')
      },
      onPageLoad(){
        let loader = pageStartLoader(this)
        axios.get(sample_resource, {headers: {count: 0}})
          .then((res) => {
              loader.hide()
              this.isAuth = getLoggedInUser()
              this.totalSamples = res.data.message;
          })
          .catch((error) => {
            handleError(this, error, loader)});
        axios.get(project_resource, {headers: {count: 0}})
          .then((res) => {
              loader.hide()
              this.isAuth = getLoggedInUser()
              this.totalProjects = res.data.message.length;
          })
          .catch((error) => {
            handleError(this, error, loader)});
        axios.get(theme_resource, {headers: {count: 0}})
          .then((res) => {
              loader.hide()
              this.isAuth = getLoggedInUser()
              this.totalThemes = res.data.message.length;
          })
          .catch((error) => {
            handleError(this, error, loader)});
      },
    },
    data() {
      return {
        page_title: "Home",
        totalSamples: 0,
        totalProjects: 0,
        totalThemes: 0
      };
    },
};
</script>
